import type { FC } from 'react';

import type { VerticalProductItemType } from '@weberus/shared-types';
import { cn } from '@yanolja-rnd/nol-design-system';

import { PriceSection } from './section/price-section';
import { ThumbnailSection } from './section/thumbnail-section';
import { TitleSection } from './section/title-section';

export interface VerticalProductItemProps extends VerticalProductItemType {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  isLegacyPcSize?: boolean;
}

/**
 * 위젯_상품형 > 상품형 페이지
 * 한 가지 테마(타이틀)로 - 6개 이상의 상품 노출에 적합합니다
 * @see {@link https://www.figma.com/design/zlHuiOHmYv1ghVDbTHUSvW/%5BGUIDE%5D-%EC%9C%84%EC%A0%AF%2F%EC%98%A4%EB%8D%94%EB%A7%81?node-id=3235-20629&m=dev}
 */
export const VerticalProductItem: FC<VerticalProductItemProps> = (props) => {
  const {
    action,
    description,
    title,
    discountRate,
    price,
    priceUnit,
    imageUrl,
    hasGoldClassBadge = false,
    flightDate,
    bottomBadgeText,
    titleClassName,
    rootClassName,
    onClick,
    isLegacyPcSize,
  } = props;

  return (
    <a className={cn(rootClassName, 'text-text-neutral-main')} href={action.web} onClick={(e) => onClick?.(e)}>
      <ThumbnailSection bottomBadgeText={bottomBadgeText} hasGoldClassBadge={hasGoldClassBadge} imageUrl={imageUrl} />
      <div className="pc:px-4">
        <TitleSection title={title} titleClassName={titleClassName} />
        {!!description && (
          <div className="mt-2 overflow-hidden typography-caption-11-regular text-text-neutral-sub pc:typography-subtitle-16-regular whitespace-nowrap">
            {description}
          </div>
        )}
        {!!flightDate && (
          <div className="mt-2 overflow-hidden typography-caption-11-regular text-text-neutral-main pc:typography-subtitle-16-regular whitespace-nowrap">
            {flightDate}
          </div>
        )}
        <PriceSection discountRate={discountRate} isLegacyPcSize={isLegacyPcSize} price={price} priceUnit={priceUnit} />
      </div>
    </a>
  );
};
